export default __webpack_public_path__ + "static/media/robi.ed6d75d2.jpg";